// extracted by mini-css-extract-plugin
module.exports = {"base":"TopBanner_base__1Ok3n","closeIcon":"TopBanner_closeIcon__-2rsP","link":"TopBanner_link__iABgC","closed":"TopBanner_closed__2zwXJ"};